<div [class]="wrapperClass">
  <div
    class="min-w-72 px-5 py-3 rounded-md bg-white shadow-lg shadow-slate-200/50 relative"
    (clickOutside)="onClose()"
  >
    <div [class]="pointerClass"></div>
    <ng-content></ng-content>
  </div>
</div>
